import { Pipe, PipeTransform } from '@angular/core';
import {
  CronConfiguration,
  DailyConfiguration,
  Schedule,
  WeeklyConfiguration
} from '../../models/fabric.model';

@Pipe({
    name: 'scheduleConfig',
    standalone: false
})
export class ScheduleConfigPipe implements PipeTransform {
  transform(value: Schedule, ...arg: unknown[]): any {
    if (!value) {
      return value;
    }
    if (value.configuration.type == 'Cron') {
      const config = value.configuration as CronConfiguration;
      return {
        interval: config.interval
      };
    }
    if (value.configuration.type == 'Daily') {
      const config = value.configuration as DailyConfiguration;
      return {
        times: config.times
      };
    }
    if (value.configuration.type == 'Weekly') {
      const config = value.configuration as WeeklyConfiguration;
      return {
        times: config.times,
        weeks: config.weekdays
      };
    }
  }
}
